import { ReactElement } from 'react'
import ReactPlayer from 'react-player'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useBreakpoint from 'use-breakpoint'
import {
    BackButton,
    FlexWrapper,
    Loader,
    PageWrapper,
    SectionTitle
} from '../../../components'
import BREAKPOINTS from '../../../const/breakpoint'
import strings from '../../../locale/en'
import { RootState } from '../../../redux/store'
import { determineWidth, determineHeight } from '../Learn/helpers'
import { VideoPlayerWrapper } from './subcomponent'

const QRVideo = (): ReactElement => {
    const {
        studentsQr: { getQrData, isLoading, setSelectedQrId }
    } = useSelector(
        (state: RootState) => ({
            studentsQr: state.studentsQr
        }),
        shallowEqual
    )

    const history = useHistory()
    const { breakpoint } = useBreakpoint(BREAKPOINTS) 
    
    return (
        <PageWrapper>
            <FlexWrapper hasBorder>
                <BackButton
                    handleBack={() => {
                        history.goBack()
                    }}
                />
                <SectionTitle title={strings.studentQR.video} />
            </FlexWrapper>
            {isLoading ? (
                <Loader />
            ) : (
                <FlexWrapper>
                    <VideoPlayerWrapper onContextMenu={(e: any) => e.preventDefault()}>
                        <ReactPlayer
                            config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                            url={getQrData.data.videoUrl || setSelectedQrId}
                            controls
                            playing={true}
                            width={determineWidth(breakpoint)}
                            height={determineHeight(breakpoint)}
                        />
                    </VideoPlayerWrapper>
                </FlexWrapper>
            )}
        </PageWrapper>
    )
}

export default QRVideo
